"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HashHistoryPageStackDisplay = exports.registerExtraCodedBlockProp = exports.registerExtraCodedPackage = exports.evalContextVarExpr = exports.localize = exports.ControlBlock = exports.ListEditor = exports.LeafBlock = exports.defaultBlockPaletteEntries = exports.DataSourceDatabase = exports.QueryCompiler = exports.PageStackDisplay = exports.ActionLibrary = exports.WidgetLibraryDesigner = exports.BlockFactory = void 0;
require("./index.css");
var BlockFactory_1 = require("./widgets/BlockFactory");
Object.defineProperty(exports, "BlockFactory", { enumerable: true, get: function () { return __importDefault(BlockFactory_1).default; } });
var widgetLibrary_1 = require("./designer/widgetLibrary");
Object.defineProperty(exports, "WidgetLibraryDesigner", { enumerable: true, get: function () { return widgetLibrary_1.WidgetLibraryDesigner; } });
var ActionLibrary_1 = require("./widgets/ActionLibrary");
Object.defineProperty(exports, "ActionLibrary", { enumerable: true, get: function () { return ActionLibrary_1.ActionLibrary; } });
var PageStackDisplay_1 = require("./PageStackDisplay");
Object.defineProperty(exports, "PageStackDisplay", { enumerable: true, get: function () { return PageStackDisplay_1.PageStackDisplay; } });
var QueryCompiler_1 = require("./database/QueryCompiler");
Object.defineProperty(exports, "QueryCompiler", { enumerable: true, get: function () { return QueryCompiler_1.QueryCompiler; } });
var DataSourceDatabase_1 = require("./database/DataSourceDatabase");
Object.defineProperty(exports, "DataSourceDatabase", { enumerable: true, get: function () { return DataSourceDatabase_1.DataSourceDatabase; } });
var blockPaletteEntries_1 = require("./designer/blockPaletteEntries");
Object.defineProperty(exports, "defaultBlockPaletteEntries", { enumerable: true, get: function () { return blockPaletteEntries_1.defaultBlockPaletteEntries; } });
__exportStar(require("./widgets/blocks"), exports);
__exportStar(require("./widgets/actions"), exports);
var LeafBlock_1 = require("./widgets/LeafBlock");
Object.defineProperty(exports, "LeafBlock", { enumerable: true, get: function () { return __importDefault(LeafBlock_1).default; } });
__exportStar(require("./widgets/propertyEditors"), exports);
__exportStar(require("./contexts"), exports);
__exportStar(require("./PageStack"), exports);
__exportStar(require("./database/Database"), exports);
__exportStar(require("./widgets/columnValues"), exports);
var ListEditor_1 = require("./widgets/ListEditor");
Object.defineProperty(exports, "ListEditor", { enumerable: true, get: function () { return __importDefault(ListEditor_1).default; } });
var ControlBlock_1 = require("./widgets/blocks/controls/ControlBlock");
Object.defineProperty(exports, "ControlBlock", { enumerable: true, get: function () { return ControlBlock_1.ControlBlock; } });
__exportStar(require("./embeddedExprs"), exports);
__exportStar(require("./database/VirtualDatabase"), exports);
var localization_1 = require("./widgets/localization");
Object.defineProperty(exports, "localize", { enumerable: true, get: function () { return localization_1.localize; } });
var evalContextVarExpr_1 = require("./widgets/evalContextVarExpr");
Object.defineProperty(exports, "evalContextVarExpr", { enumerable: true, get: function () { return evalContextVarExpr_1.evalContextVarExpr; } });
var CodedBlock_1 = require("./widgets/blocks/coded/CodedBlock");
Object.defineProperty(exports, "registerExtraCodedPackage", { enumerable: true, get: function () { return CodedBlock_1.registerExtraCodedPackage; } });
Object.defineProperty(exports, "registerExtraCodedBlockProp", { enumerable: true, get: function () { return CodedBlock_1.registerExtraCodedBlockProp; } });
var HashHistoryPageStackDisplay_1 = require("./HashHistoryPageStackDisplay");
Object.defineProperty(exports, "HashHistoryPageStackDisplay", { enumerable: true, get: function () { return HashHistoryPageStackDisplay_1.HashHistoryPageStackDisplay; } });
